
<template>
  <div>
    <apexchart type="donut" :options="chartOptions" :series="series" :width="width"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'DonutChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
      series: {
          type: Array,
          required: true
      },
      labels: {
          type: Array,
          default: () => []
      },
      colors: {
          type: Array,
          default: () => ['#ad88f1']
      },
      width: {
          type: Number,
          default: 400
      }
  },
  computed: {
      chartOptions() {
          return {
              chart: {
                  type: 'donut',
                  dropShadow: {
                      enabled: true,
                      color: '#111',
                      top: -1,
                      left: 3,
                      blur: 3,
                      opacity: 0.2
                  }
              },
              plotOptions: {
                  pie: {
                      donut: {
                          labels: {
                              show: true,
                              total: {
                                  showAlways: true,
                                  show: true
                              }
                          }
                      }
                  }
              },
              labels: this.labels,
              dataLabels: {
                  dropShadow: {
                      blur: 3,
                      opacity: 0.8
                  }
              },
              states: {
                  hover: {
                      filter: 'none'
                  }
              },
              theme: {
                  palette: 'palette2'
              },
              
              colors: this.colors,
          }
          
      }
  }
}
</script>
<style scoped>
.donut-chart-container {
  width: 350px; /* Ajusta el tamaño deseado */
  height: auto; /* Opcional, para mantener la proporción */
  margin: 0 auto; /* Centrar el gráfico */
}
</style>